import React, { useState, useEffect } from 'react';
import ApiService from '../../functions/apiService';
import { Grid, Typography, TextField, Autocomplete, Box, CircularProgress } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { toast } from 'react-toastify';
import Multiselect from 'multiselect-react-dropdown';
import AddChecklistHierarchy from './AddChecklistHierarchy';
import './checklist.css'

const durationOptions = [
  { label: "Daily", value: "daily" },
  { label: "Every Other Day", value: "everyotherday" },
  { label: "Weekly", value: "weekly" },
  { label: "Bi-weekly", value: "biweekly" },
  { label: "Monthly", value: "monthly" }
]

const dayOptions = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" }
]

const DuplicateChecklist = ({ show, onHide, checklistId, onDuplicated }) => {
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [employees, setEmployees] = useState([])
  const [employeesNew, setEmployeesNew] = useState([])
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [locationDrop, setLocationDrop] = useState([]);
  const [duration, setDuration] = useState("");
  const [date, setDate] = useState(new Date());
  const [day, setDay] = useState("")
  const [assignedTo, setAssignedTo] = useState(null);
  const [position, setPosition] = useState(null);
  const [positionDrop, setPositionDrop] = useState([]);
  const [time, setTime] = useState(null);
  const [ticketAssignTo, setTicketAssignTo] = useState(null);
  const [ticketNotifyTo, setTicketNotifyTo] = useState([]);
  const [checklistUpdateTo, setChecklistUpdateTo] = useState(null);
  const [nestedData, setNestedData] = useState([]);
  const [targets, setTargets] = useState([])
  const [hasPrefilled, setHasPrefilled] = useState(false);

  const resetState = () => {
    setTitle("");
    setLocation("");
    setDuration("");
    setDate(new Date());
    setDay("");
    setAssignedTo(null);
    setPosition(null);
    setTime(null);
    setTicketAssignTo(null);
    setTicketNotifyTo([]);
    setChecklistUpdateTo(null);
    setNestedData([]);
    setTargets([]);
    setHasPrefilled(false);
  }

  const loadEmployees = () => {
    ApiService.get('/employee-list-inventory')
      .then(({ data }) => {
        var tempArr = data?.data.map((emp) => ({
          label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
          value: emp.Emp_Code
        }))
        setEmployees(tempArr)
      })
      .catch((e) => { console.error(e) })

    ApiService.get('/employee-list-inventory-new')
      .then(({ data }) => {
        var tempArr = data?.data.map((emp) => ({
          label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
          value: emp.Emp_Code
        }))
        setEmployeesNew(tempArr)
      })
      .catch((e) => { console.error(e) })
  }

  const getPositionDropown = () => {
    ApiService.get('/positions-list')
      .then(({ data }) => {
        var certArr = data?.data.map((cer) => ({ label: cer.SO_Desc, value: cer.SO_Value }))
        setPositionDrop(certArr)
      })
      .catch((e) => { console.error(e) })
  }

  const getLocation = () => {
    ApiService.get('/checklist/location')
      .then(({ data }) => {
        var posArr = data?.data.map((pos) => ({ label: pos.location_description, value: pos.id }))
        setLocationDrop(posArr)
      })
      .catch((e) => { console.error(e) })
  }

  const markAllSelected = (node) => {
    node.selected = true;
    if (node.locations && node.locations.length > 0) {
      node.locations = node.locations.map(markAllSelected);
    }
    if (node.items && node.items.length > 0) {
      node.items = node.items.map(item => ({ ...item, selected: true }));
    }
    return node;
  };

  const markInChecklistSelected = (node) => {
    if (node?.in_checklist === 'yes') {
      node.selected = true;
      node.desc = node.checklist_item_description || '';
    }
    if (Array.isArray(node.items)) {
      node.items.forEach(item => {
        if (item.in_checklist === 'yes') {
          item.selected = true;
          item.desc = item.checklist_item_description || '';
        }
      });
    }
    if (Array.isArray(node.locations)) {
      node.locations.forEach(loc => markInChecklistSelected(loc));
    }
    return node;
  };

  // Fresh hierarchy (all selected by default) for a location the user picks manually
  const loadFreshHierarchy = (locationId) => {
    const body = { "id": locationId };
    ApiService.post('/checklist/hirearchy_data', body)
      .then((data) => {
        const updatedData = markAllSelected(data?.data);
        setNestedData(updatedData);
      }).catch((e) => { console.error(e) })
  }

  // Pre-selected hierarchy matching the checklist being duplicated
  const loadDuplicateHierarchy = (id) => {
    ApiService.get(`/checklist/edit_items/${id}`)
      .then((data) => {
        const tempObj = data?.data?.data;
        if (!tempObj) return;
        if (tempObj?.items?.length > 0) {
          tempObj.items.forEach((item) => {
            if (item?.in_checklist === 'yes') {
              item.selected = true;
              item.desc = item.checklist_item_description || '';
            }
          });
        }
        if (tempObj?.locations?.length > 0) {
          tempObj.locations = tempObj.locations.map(loc => markInChecklistSelected(loc));
        }
        setNestedData(tempObj);
      })
      .catch((e) => { console.error(e) })
  }

  const getChecklistPrefill = (id) => {
    setDataLoading(true);
    ApiService.get('/checklist/edit_details/' + id)
      .then(({ data }) => {
        setTitle(data?.data?.title ? `${data?.data?.title}` : "")
        setLocation(data?.data?.location_id || "")
        setDuration(data?.data?.duration || "")
        setDay(data?.data?.day || "")
        if (data?.data?.day) {
          setDate(new Date(data?.data?.day))
        }
        if (data?.data?.time) {
          setTime(new Date(`${moment().format('YYYY-MM-DD')} ${data?.data?.time}`))
        }
        setDataLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setDataLoading(false);
      })
  }

  useEffect(() => {
    if (show && checklistId) {
      resetState();
      loadEmployees();
      getPositionDropown();
      getLocation();
      getChecklistPrefill(checklistId);
      loadDuplicateHierarchy(checklistId);
    }
  }, [show, checklistId]);

  // Once dropdown options and the checklist data are both loaded, map assigned values
  useEffect(() => {
    if (!show || dataLoading) return;
    if (employees.length == 0 && employeesNew.length == 0) return;

    ApiService.get('/checklist/edit_details/' + checklistId)
      .then(({ data }) => {
        var tempAssign = employeesNew.find(a => a.value == data?.data?.checklist_assign?.emp_id)
        setAssignedTo(tempAssign || null)
        var tempPos = positionDrop.find(a => a.value == data?.data?.checklist_assign?.position)
        setPosition(tempPos || null)
        var tempAssignTicket = employees.find(a => a.value == data?.data?.ticket_assigned_to)
        setTicketAssignTo(tempAssignTicket || null)
        let notifyEmpCodes = data?.data?.notify?.map(n => n.notify_emp_code) || []
        var tempNotifyTicket = employeesNew.filter(a => notifyEmpCodes.includes(a.value))
        setTicketNotifyTo(tempNotifyTicket)
        var tempUpdateChecklist = employees.find(a => a.value == data?.data?.notify_checklist_update_to)
        setChecklistUpdateTo(tempUpdateChecklist || null)
        setHasPrefilled(true);
      })
      .catch((e) => { console.error(e) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, dataLoading, employees, employeesNew, positionDrop]);

  // Reload the hierarchy when the user manually changes the location after prefill
  useEffect(() => {
    if (!hasPrefilled || !location) return;
    loadFreshHierarchy(location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const buildSubTree = (node) => {
    if (!node.selected) return null;

    const result = {
      description: node.desc || '',
      location_id: node.id,
      parent_location_id: node.location_parent_id,
      type: node.type || (node.item ? 'item' : 'location'),
    };

    const items = node.items?.filter(i => i.selected).map(item => ({
      description: item.desc || '',
      item_id: item.item_id,
      parent_location_id: item.location_id,
      type: 'item'
    }));

    const subLocations = node.locations?.map(buildSubTree).filter(Boolean);

    if (items?.length) result["items"] = items;
    if (subLocations?.length) result["sub-location"] = subLocations;

    return result;
  };

  const buildTargets = (rootNode) => {
    if (!rootNode?.selected && !rootNode?.locations && !rootNode?.items) return [];

    const built = [];

    rootNode.locations?.forEach(child => {
      const target = buildSubTree(child);
      if (target) built.push(target);
    });

    rootNode.items?.forEach(item => {
      if (item.selected) {
        built.push({
          description: item.desc || '',
          item_id: item.item_id,
          parent_location_id: item.location_id,
          type: 'item'
        });
      }
    });

    return built;
  };

  useEffect(() => {
    const updatedTargets = buildTargets(nestedData);
    setTargets(updatedTargets);
  }, [nestedData]);

  const duplicateChecklist = () => {
    var tempDay = (duration == 'monthly' || duration == 'everyotherday') ? moment(date).format('YYYY-MM-DD') : day
    const body = {
      "title": title,
      "parent_location_id": location,
      "duration": duration,
      "day": tempDay,
      "assignedTo": assignedTo?.value,
      "position": position?.value,
      "time": time ? moment(time).format('HH:mm:ss') : "",
      "ticket_assigned_to": ticketAssignTo?.value,
      "notify_employees": ticketNotifyTo.map((a) => a?.value),
      "notify_checklist_update_to": checklistUpdateTo?.value,
      "targets": targets,
    }
    setLoading(true);
    ApiService.post('/checklist/add', body)
      .then((data) => {
        setLoading(false);
        toast.success(data.message)
        onDuplicated && onDuplicated();
        onHide();
      })
      .catch((error) => {
        setLoading(false);
        if (error.status === 422) {
          const errorMessages = Object.keys(error?.data?.errors || {})
            .map((err) => error.data.errors[err][0])
            .filter(Boolean);

          if (errorMessages.length) {
            toast.error(
              <div>
                {errorMessages.map((msg, index) => (
                  <div key={index}>• {msg}</div>
                ))}
              </div>
            );
          }
        } else {
          toast.error(error?.data?.message);
        }
      })
  }

  return (
    <Modal show={show} size="xl" onHide={onHide} className='font-fam'>
      <Modal.Header closeButton>
        <Modal.Title>Duplicate Checklist Definition</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 22 }}>
        {dataLoading ? (
          <Box className="w-100 d-flex justify-content-center align-items-center" style={{ height: 300 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2}>

            {/* Title */}
            <Grid item xs={12} sm={6} md={6}>
              <label className='my-2'>Title Enter*</label>
              <TextField
                fullWidth
                variant="outlined"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter Title"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "48px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }
                }}
              />
            </Grid>

            {/* Parent Location */}
            <Grid item xs={12} sm={6} md={6}>
              <label className='my-2'>Parent Location*</label>
              <Autocomplete
                options={locationDrop}
                getOptionLabel={(option) => option.label}
                value={locationDrop.find(l => l.value == location) || null}
                onChange={(event, newValue) => setLocation(newValue?.value || "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Location"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "48px",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center"
                      }
                    }}
                  />
                )}
              />
            </Grid>

            {/* Hierarchy Box */}
            <Grid item xs={12} sm={6} md={12} sx={{ marginBottom: '20px' }}>
              {location > 0 && nestedData &&
                <Box className='lines' style={{ paddingBottom: '6px' }}>
                  <AddChecklistHierarchy
                    key={nestedData.id}
                    propdata={nestedData}
                    loadData={() => loadFreshHierarchy(location)}
                    location={location}
                    parentSelected={nestedData.selected}
                    setNestedData={setNestedData}
                  />
                </Box>
              }
            </Grid>

            {/* Postion */}
            <Grid item xs={12} sm={6} md={4}>
              <label className='my-2'>Assign by Position*</label>
              <Autocomplete
                options={positionDrop}
                disabled={assignedTo != null}
                onChange={(event, newValue) => setPosition(newValue)}
                value={position}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "48px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Position" />
                )}
              />
            </Grid>

            {/* Assigned to */}
            <Grid item xs={12} sm={6} md={4}>
              <label className='my-2'>Assign by Employee*</label>
              <Autocomplete
                options={employeesNew}
                disabled={position != null}
                value={assignedTo}
                onChange={(event, newValue) => { setAssignedTo(newValue) }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "48px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Employee" />
                )}
              />
            </Grid>

            {/* Duration */}
            <Grid item xs={12} sm={6} md={4}>
              <label className='my-2'>Duration*</label>
              <Autocomplete
                options={durationOptions}
                getOptionLabel={(option) => option.label}
                value={duration ? durationOptions.find(opt => opt.value === duration) || null : null}
                onChange={(_, newValue) => setDuration(newValue ? newValue.value : "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    placeholder="Select Duration"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "48px",
                        fontSize: "14px"
                      }
                    }}
                  />
                )}
              />
            </Grid>

            {/* Calender*/}
            {(duration == 'monthly' || duration == 'everyotherday') &&
              <Grid item xs={12} sm={6} md={4} className='d-grid'>
                <label className='my-2'>Date*</label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <ButtonDatePicker
                    className='w-100'
                    label={moment(date).format('YYYY-MM-DD')}
                    value={date}
                    onChange={(e) => setDate(e)}
                    minDate={new Date()}
                  />
                </LocalizationProvider>
              </Grid>
            }

            {/*Select Days drop down */}
            {(duration == 'weekly' || duration == 'biweekly') &&
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Select Day*</label>
                <Autocomplete
                  options={dayOptions}
                  getOptionLabel={(option) => option.label}
                  value={day ? dayOptions.find(opt => opt.value === day) || null : null}
                  onChange={(_, newValue) => setDay(newValue ? newValue.value : "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      placeholder="Select Day"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "48px",
                          fontSize: "14px"
                        }
                      }}
                    />
                  )}
                />
              </Grid>}

            {/* Time Dropdown */}
            <Grid item xs={12} sm={6} md={4}>
              <label className='my-2'>Time*</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  value={time}
                  onChange={(newValue) => setTime(newValue)}
                  className='mt-0'
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      height: '48px',
                      fontSize: '14px'
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            {/* Ticket Assign to */}
            <Grid item xs={12} sm={6} md={4}>
              <label className='my-2'>Assign Ticket to</label>
              <Autocomplete
                options={employees}
                value={ticketAssignTo}
                onChange={(event, newValue) => { setTicketAssignTo(newValue) }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "48px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Employee" />
                )}
              />
            </Grid>

            {/* Ticket Notify to */}
            <Grid item xs={12} sm={6} md={4}>
              <label className='my-2'>Notify Ticket to</label>
              <Multiselect
                displayValue="label"
                options={employeesNew}
                showCheckbox
                showArrow
                customCloseIcon={<><img src='/images/cross.png' /></>}
                placeholder='Select Employees'
                selectedValues={ticketNotifyTo}
                onSelect={(e) => setTicketNotifyTo(e)}
                onRemove={(e) => setTicketNotifyTo(e)}
              />
            </Grid>

            {/* Notify Checklist Update to */}
            <Grid item xs={12} sm={6} md={4}>
              <label className='my-2'>Notify Checklist Update to*</label>
              <Autocomplete
                options={employees}
                value={checklistUpdateTo}
                onChange={(event, newValue) => { setChecklistUpdateTo(newValue) }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "48px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center"
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Employee" />
                )}
              />
            </Grid>
          </Grid>
        )}
      </Modal.Body>

      <Modal.Footer>
        <ButtonTheme
          variant="filled"
          color='#D0D5DD'
          className='px-5'
          onClick={onHide}
        >
          Cancel
        </ButtonTheme>
        <ButtonTheme
          type='submit'
          variant="filled"
          color='primary'
          className='mx-2 px-5'
          disabled={dataLoading || loading}
          onClick={duplicateChecklist}
        >
          {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Duplicate'}
        </ButtonTheme>
      </Modal.Footer>
    </Modal>
  );
}

export default DuplicateChecklist;
